import {useCallback} from 'react';

import {matchAllMetrics} from '../../../state/interactState/constants';
import {useSetHighlight} from '../../../state/interactState/hooks';

const delay = 200;
let sharedTimer: ReturnType<typeof setTimeout> | undefined;

export function useRunHighlighter(runId: string) {
  const setActive = useSetHighlight();

  const handleMouseOut = useCallback(() => {
    sharedTimer = setTimeout(() => {
      setActive('run:name', undefined, undefined);
    }, delay);
  }, [setActive]);

  const handleMouseIn = useCallback(() => {
    setActive('run:name', runId, matchAllMetrics);
    if (sharedTimer) {
      clearTimeout(sharedTimer);
    }
  }, [setActive, runId]);

  return {
    handleMouseIn,
    handleMouseOut,
  };
}
